/*
 * @创建文件时间: 2019-11-13 11:54:43
 * @最后修改人: lfq
 * @最后修改时间: 2020-07-07 16:13:42
 * @联系Qq:1638245306
 * @文件介绍: 交安设施
 */
export default [{
        path: 'bdAntiglareTable',
        name: 'bdAntiglareTable',
        meta: {
            title: '交安设施管理',
            auth: true
        },
        component: () =>
            import ('@/views/basic/appendant/bdAntiglareTable')
    }, {
        path: 'bdAntiglareBoardTable',
        name: 'bdAntiglareBoardTable',
        meta: {
            title: '防眩板',
            auth: true
        },
        component: () =>
            import ('@/views/basic/appendant/bdAntiglareBoardTable')
    }, {
        path: 'bdAntiglareNetTable',
        name: 'bdAntiglareNetTable',
        meta: {
            title: '防眩网',
            auth: true
        },
        component: () =>
            import ('@/views/basic/appendant/bdAntiglareNetTable')
    }, {
        path: 'bdAttachedMarkTable',
        name: 'bdAttachedMarkTable',
        meta: {
            title: '附着式轮廓标',
            auth: true
        },
        component: () =>
            import ('@/views/basic/appendant/bdAttachedMarkTable')
    }, {
        path: 'bdBridgeProtectNetTable',
        name: 'bdBridgeProtectNetTable',
        meta: {
            title: '桥梁护网',
            auth: true
        },
        component: () =>
            import ('@/views/basic/appendant/bdBridgeProtectNetTable')
    }, {
        path: 'bdGuardBarTable',
        name: 'bdGuardBarTable',
        meta: {
            title: '护栏',
            auth: true
        },
        component: () =>
            import ('@/views/basic/appendant/bdGuardBarTable')
    }, {
        path: 'bdHundredBrandTable',
        name: 'bdHundredBrandTable',
        meta: {
            title: '百米牌(桩)',
            auth: true
        },
        component: () =>
            import ('@/views/basic/appendant/bdHundredBrandTable')
    }, {
        path: 'bdInformationBoardTable',
        name: 'bdInformationBoardTable',
        meta: {
            title: '可变情报板',
            auth: true
        },
        component: () =>
            import ('@/views/basic/appendant/bdInformationBoardTable')
    }, {
        path: 'bdIsolatedGridTable',
        name: 'bdIsolatedGridTable',
        meta: {
            title: '隔离栅',
            auth: true
        },
        component: () =>
            import ('@/views/basic/appendant/bdIsolatedGridTable')
    }, {
        path: 'bdMovableRailTable',
        name: 'bdMovableRailTable',
        meta: {
            title: '活动护栏',
            auth: true
        },
        component: () =>
            import ('@/views/basic/appendant/bdMovableRailTable')
    }, {
        path: 'bdPillarMarkTable',
        name: 'bdPillarMarkTable',
        meta: {
            title: '柱式轮廓标',
            auth: true
        },
        component: () =>
            import ('@/views/basic/appendant/bdPillarMarkTable')
    }, {
        path: 'bdSignLineTable',
        name: 'bdSignLineTable',
        meta: {
            title: '标线',
            auth: true
        },
        component: () =>
            import ('@/views/basic/appendant/bdSignLineTable')
    },
    {
        path: 'bdSignBoardTable',
        name: 'bdSignBoardTable',
        meta: {
            title: '道路交通标志',
            auth: true
        },
        component: () =>
            import ('@/views/basic/appendant/bdSignBoardTable')
    },

]